import {
  ArrowDownLeft,
  CalendarClock,
  CreditCard,
  HandCoins,
  Receipt,
  Repeat,
  Scissors,
  type LucideIcon,
} from "lucide-react";
import { Badge, ListRow, Money } from "@/components/ui";
import { relativeDay } from "@/lib/format";
import type { CalendarEvent } from "@/lib/types";

export const EVENT_META: Record<
  CalendarEvent["kind"],
  { icon: LucideIcon; label: string; tint: string }
> = {
  income: { icon: ArrowDownLeft, label: "Ingreso", tint: "var(--positive)" },
  card_due: { icon: CreditCard, label: "Pago de tarjeta", tint: "var(--series-1)" },
  msi: { icon: CalendarClock, label: "Mensualidad MSI", tint: "var(--series-1)" },
  debt: { icon: HandCoins, label: "Deuda", tint: "var(--series-2)" },
  bill: { icon: Receipt, label: "Gasto fijo", tint: "var(--muted)" },
  subscription: { icon: Repeat, label: "Suscripción", tint: "var(--accent)" },
  cut_off: { icon: Scissors, label: "Fecha de corte", tint: "var(--muted)" },
};

export function EventIcon({ kind }: { kind: CalendarEvent["kind"] }) {
  const meta = EVENT_META[kind] ?? { icon: CalendarClock, tint: "var(--muted)" };
  const Icon = meta.icon;
  return (
    <span
      className="grid size-9 place-items-center rounded-[10px]"
      style={{ background: `color-mix(in oklab, ${meta.tint} 14%, transparent)`, color: meta.tint }}
      aria-hidden
    >
      <Icon className="size-[18px]" />
    </span>
  );
}

export function EventRow({ event, showDate = true }: { event: CalendarEvent; showDate?: boolean }) {
  const status = event.overdue ? (
    <Badge tone="negative">Vencido</Badge>
  ) : event.done ? (
    <Badge tone="positive">Pagado</Badge>
  ) : null;
  const label =
    event.installment && event.of
      ? `${EVENT_META[event.kind].label} · ${event.installment}/${event.of}`
      : EVENT_META[event.kind].label;
  return (
    <ListRow
      leading={<EventIcon kind={event.kind} />}
      title={
        <span className="flex items-center gap-1.5">
          <span className="truncate">{event.title}</span>
          {status}
        </span>
      }
      subtitle={showDate ? `${relativeDay(event.date)} · ${label}` : label}
      trailing={
        event.amount ? (
          <Money
            value={event.kind === "income" ? `-${event.amount}` : event.amount}
            signed
            className="font-medium"
          />
        ) : null
      }
    />
  );
}
